import { useNavigate, useParams } from 'react-router-dom';
//MUI
import { Stack, TextField, InputAdornment, Box, useTheme } from '@mui/material';
import Search from '@mui/icons-material/Search';
import { SearchBoxSeperator, SearchButton } from 'theme/elements/Buttons';
//reducers
import { selectTranslations } from 'state/reducers/translation.reducers';
import { useAppSelector } from 'hooks/redux.hooks';
//components
import MultipleSelectCheckmarks, { SelectedList } from 'components/formElements/MultipleSelectCheckmarks';
//constants
import { dataType, filterList, filterProps, FilterType } from './types';
import _ from 'lodash';
import FilterDateRange from 'components/formElements/DateRange';
import { ThemeContext } from '@emotion/react';
import { getMobile } from 'state/reducers/ui.reducers';
import { useEffect, useState } from 'react';

export function getFilteredData(data: dataType[], filterList: filterList, searchColumns: string[] = []) {
  if (_.keys(filterList).length > 0) {
    try {
      return _.filter(data, function (record) {
        let exist = true;
        _.keys(filterList).forEach((column) => {
          if (_.isEqual('termSearch', column) && searchColumns.length > 0) {
            exist = !_.includes(
              _.toLower(_.join(_.values(_.pick(record, searchColumns)))),
              String(filterList[column])
            )
              ? false
              : exist;
          } else {
            exist = !_.has(_.groupBy(filterList[column], 'value'), record[column]) ? false : exist;
          }
        });
        return exist;
      });
    } catch (e) { }
  }
  return data;
}

export default function FilterNavbar(props: filterProps) {
  const { reference } = useParams();
  const [inputValue, setInputValue] = useState('');
  const [isNavbarSearchMode, setIsNavbarSearchMode] = useState(false);
  const theme = useTheme();
  const t = useAppSelector(selectTranslations);
  const { filterList, data, handleChange, tableState, includeSearchBox } = props;
  const handleDropboxOnChange = (column: string, list: SelectedList) => {
    let filterData = { ...tableState.filters, [column]: list };
    if (list.length < 1 && _.has(filterData, column)) {
      delete filterData[column];
    }
    handleChange({ ...tableState, filters: filterData, page: 0 });
  };
  const handleOnChange = (event?, searchWord?) => {
    const searchBy = event ? event.target.value : searchWord;
    let filterData = { ...tableState.filters, termSearch: searchBy.toLowerCase() };
    handleChange({ ...tableState, filters: filterData, page: 0 });
  };
  const isMobile = useAppSelector(getMobile);

  useEffect(() => {
    if (reference) {
      setIsNavbarSearchMode(true);
      setInputValue(reference);
      handleOnChange(null, inputValue);
    }
  }, [reference, inputValue, isNavbarSearchMode]);

  return (
    <Stack flexDirection="row" gap={1} flexWrap={{ xs: 'wrap', sm: 'inherit' }}>
      {includeSearchBox && (
        <SearchButton>
          <TextField
            sx={{ height: '32px', width: '100%' }}
            onChange={handleOnChange}
            size="small"
            variant="outlined"
            id="outlined-start-adornment"
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <Search />
                </InputAdornment>
              ),
            }}
          />
        </SearchButton>
      )}
      {includeSearchBox && !isMobile && <SearchBoxSeperator />}
      <Stack
        sx={{
          [theme.breakpoints.down('sm')]: {
            overflowX: 'scroll',
            /*paddingBottom:'8px',
                            "&::-webkit-scrollbar": {
                            height: '6px',
                            // marginTop:2,
                            },
                            "&::-webkit-scrollbar-track": {
                            backgroundColor: theme.palette.root.darkGrayed_024,
                            },
                            "&::-webkit-scrollbar-thumb": {
                            backgroundColor:  theme.palette.root.darkGrayed_028,
                            borderRadius: 2
                            }*/
          },
        }}
        flexDirection="row"
        gap={1}
      >
        {_.keys(filterList).map((column, inx) => {
          let options: SelectedList = [];
          switch (_.get(filterList, column)?.type) {
            case FilterType.unique:
              let uniques = _.keys(_.groupBy(data, column));
              uniques.forEach((val) => {
                if (val !== 'null') {
                  options.push({ name: val, value: val });
                }
              });

              return (
                <MultipleSelectCheckmarks
                  key={inx}
                  label={_.get(filterList, column)?.label}
                  options={options}
                  handleChange={(list) => handleDropboxOnChange(column, list)}
                  primaryOption={_.get(filterList, column)?.primaryOption}
                />
              );
            case FilterType.search:
              return (
                <SearchButton key={inx}>
                  <TextField
                    sx={{ height: '32px' }}
                    onChange={handleOnChange}
                    size="small"
                    id="outlined-start-adornment"
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <Search />
                        </InputAdornment>
                      ),
                    }}
                  />
                </SearchButton>
              );
            case FilterType.dateRange:
              return (
                <FilterDateRange
                  key={inx}
                  handleChangeOnClose={props.handleChangeOnClose}
                  isNavbarSearchMode={isNavbarSearchMode}
                  value={_.get(filterList, column)?.value}
                  label={_.get(filterList, column)?.label}
                  handleChange={_.get(filterList, column)?.handleChange}
                  handleTableState={() => {
                    handleChange({ ...tableState, page: 0 });
                  }}
                />
              );
          }
        })}
      </Stack>
      {props.HeaderComponent && props.HeaderComponent}
    </Stack>
  );
}
